import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { useDispatch } from "react-redux";
import {
  VfsLoader,
  VfsWebsiteRequest,
} from "../../../Redux/Action/VfsAction";
import { GetCountryList } from "../../../Redux/Action/CorporateAction";
import { useSelector } from "react-redux";
import Select from "react-select";

export const VfsRefundRequest = ({
  setRefundModal,
}) => {
  const dispatch = useDispatch();
  // get token from local storage
  const authToken = localStorage.getItem("Admin");
  const token = JSON.parse(authToken)?.data?.token;

  const [formData,setForm]=useState({
    name:"",
    contact:"",
    email:"",
    invoiceId:"",
    note:"",
    countryCode:"+91",
    reason:""
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
       ...formData,
       contact: formData.contact?.trim(),
       email: formData.email?.trim(),
       invoiceId: formData.invoiceId?.trim(),
       note: formData.note?.trim(),
       name: formData.name?.trim(),
      };
      dispatch(VfsWebsiteRequest(data, setRefundModal));
    } catch (error) {
    }
  };
  const countryList = useSelector((state) => state?.corporateData?.CountryList?.data);
  const [countryOption, setCountryOption] = useState("");
  const [countryCodeoption, setCountryCodeOption] = useState([]);
  
  useEffect(() => {
      dispatch(GetCountryList());
  }, []);

  const customComponents = {
    IndicatorSeparator: () => null,
};

  const customStylescountrycode = {
    control: (provided, state) => ({
        ...provided,
        minWidth: '100px',
        maxWidth: '150px',
        overflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // maxWidth: window?.innerWidth > 600 && '210px',
        borderColor: state.isFocused ? '#fff100' : '#ececec',
        boxShadow: 'none',
        backgroundColor: '#fff',
        '&:hover': { borderColor: '#ececec' },
    }),
    placeholder: (base) => ({
        ...base,
        color: '#262626',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        height: '50px',
        overflow: 'hidden',
        borderColor: '#d1d5db'
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#262626',
        height: '50px',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: 'transparent',
        color: 'black',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: '#f8f8f8',
        },
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: '200px',
        overflowY: 'auto',
        padding: 0,
    }),
};
  useEffect(() => {
      if (countryList && countryList?.length > 0) {
          const con = countryList.map((item) => ({
              label: item.name,
              value: item.id,
              phonecode: item.phonecode,
          }));
          setCountryOption(con);
      }
  }, [countryList]);
  useEffect(() => {
      if (countryList && countryList?.length > 0) {
          const con = countryList.map((item) => ({
              label: `+${item.phonecode}`,
              value: item.phonecode,
          }));
          setCountryCodeOption(con);
      }
  }, [countryList]);


  const refundReasonOptions = [
    { value: "approve", label: "Approve" },
    { value: "reject", label: "Reject" },
    { value: "pending", label: "Pending" },
    { value: "other", label: "Other" },

  ]
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#fff100' : '#ececec',
      boxShadow: 'none',
      '&:hover': { borderColor: '#ececec' },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#262626',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '2px 8px',
      height: '38px',
      overflow: 'hidden',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      color: '#262626',
      height: '38px',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: 'transparent',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: '#f8f8f8',
      },
    }),
    menuList : (provided) => ({
      ...provided,
      maxHeight : '200px',
      overflowY : 'auto',
      padding: 0,
    }),
  };
  return (
    <>
     <div className="bg-black fixed top-0 left-0 right-0 w-full h-full z-30 bg-opacity-50">
  <div
    className="bg-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl rounded-[10px] w-[90%] sm:w-[450px] md:w-[500px] lg:w-[600px] flex flex-col max-h-[90vh]"
  >
    {/* Header */}
    <div className="rounded-t-2xl px-5 md:px-3 xl:px-5 py-2 xl:py-3 font-Poppins text-xl flex justify-between items-center flex-shrink-0">
      <div className="text-[18px] xl:text-xl text-gray-900">
        Payment Refund Request
      </div>
      <button onClick={() => setRefundModal(false)}>
        <MdClose className="text-gray-500 text-2xl hover:text-black" />
      </button>
    </div>
    <hr />

    {/* Scrollable Content */}
    <div className="px-4 py-6 sm:px-6 lg:px-8 overflow-y-auto flex-1">
      <form className="space-y-6" id="yourFormId" onSubmit={handleSubmit} >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-semibold text-gray-700"
            >
              Full Name *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="w-full px-4 py-3 placeholder:text-[14px] md:placeholder:text-[16px] border border-gray-300 rounded-[4px] focus:ring-0 focus:ring-transparent focus:border-transparent transition-all duration-300"
              placeholder="Enter your registered full name"
            />
          </div>

          {/* Email */}
          <div>
            <label
              htmlFor="email"
              className="block mb-2 text-sm font-semibold text-gray-700"
            >
              Email *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="w-full px-4 py-3 text-sm md:text-base placeholder:text-sm md:placeholder:text-base border border-gray-300 rounded-md focus:border-yellow-400 focus:ring-2 focus:ring-yellow-300 transition-all duration-300"
              placeholder="Enter your registered email"
            />
          </div>
        </div>

        {/* Mobile Number and Invoice */}
        <div className="grid gap-6 grid-cols-1 md:grid-cols-6">
          <div className="col-span-4">
            <label
              htmlFor="contact"
              className="block mb-2 text-sm font-semibold text-gray-700"
            >
              Mobile Number *
            </label>
            <div className="flex">
              <Select
                options={countryCodeoption}
                components={customComponents}
                placeholder="+91"
                name="countryCode"
                id="countryCode"
                value={
                  formData.countryCode
                    ? countryCodeoption?.find(
                        (option) => option.value === formData.countryCode
                      )
                    : countryCodeoption?.find(
                        (option) => option.value === "+91"
                      )
                }
                onChange={(e) => {
                  setForm((prev) => ({
                    ...prev,
                    countryCode: e.value,
                  }));
                }}
                menuPlacement="top"
                isSearchable
                styles={{
                  ...customStylescountrycode,
                  container: (provided) => ({
                    ...provided,
                    width: "90px",
                  }),
                  control: (provided) => ({
                    ...provided,
                    minHeight: "48px",
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                  }),
                }}
              />
              <input
                type="tel"
                id="contact"
                name="contact"
                value={formData.contact}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // remove non-digits
                  handleInputChange({ target: { name: "contact", value } });
                }}
                required
                className="flex-1 min-w-0  placeholder:text-[14px] md:placeholder:text-[16px] pl-2 sm:px-4 py-3 border border-l-0 border-gray-300 rounded-r-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 appearance-none"
                placeholder="Enter your mobile number"
                pattern="[0-9]*"
                inputMode="numeric"
              />
            </div>
          </div>

          <div className="col-span-4 md:col-span-2">
            <label
              htmlFor="invoiceId"
              className="block mb-2 text-sm font-semibold text-gray-700"
            >
              Invoice No *
            </label>
            <input
              type="text"
              id="invoiceId"
              name="invoiceId"
              value={formData.invoiceId}
              onChange={handleInputChange}
              required
              className="w-full px-4 py-3 text-sm md:text-base placeholder:text-sm md:placeholder:text-base border border-gray-300 rounded-md focus:border-yellow-400 focus:ring-2 focus:ring-yellow-300 transition-all duration-300"
              placeholder="Enter invoice no."
            />
          </div>
          </div>
                                <div className="col-span-6">
                                    <label
                                      htmlFor="note"
                                      className="block mb-2 text-sm font-semibold text-gray-700"
                                    >
                                      Reason *
                                    </label>
                                    <textarea
                                      id="note"
                                      name="note"
                                      value={formData.note}
                                      onChange={handleInputChange}
                                      required
                                      rows="4"
                                      className="w-full px-4 py-3 text-sm md:text-base placeholder:text-sm md:placeholder:text-base border border-gray-300 rounded-md focus:border-yellow-400 focus:ring-2 focus:ring-yellow-300 transition-all duration-300 resize-none"
                                      placeholder="Enter your reason"
                                    />
                              </div>
        
      </form>
    </div>

    {/* Sticky Footer */}
    <div className="flex justify-center gap-4 p-4 bg-white border-t flex-shrink-0 rounded-b-2xl">
      <button
        type="submit"
        form="yourFormId" // optional: if form is outside button
        className="bg-[#FCDD00] hover:bg-yellow-400 text-black font-bold py-3 px-10 rounded-full text-sm md:text-lg transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-40 disabled:cursor-not-allowed"
      >
        Submit
      </button>
    </div>
  </div>
</div>

    </>
  );
};
